import ReactPixel from 'react-facebook-pixel';
const pixelId='640861546633334';

ReactPixel.init(pixelId,{},{debug:true});

export default ReactPixel;